import { RuntimeMediaQuery } from '@duda-co/responsive-styles/RuntimeMediaQuery';
import type { ResponsiveStylesStructured } from '@duda-co/responsive-styles/types/ResponsiveStylesTypes';
import { Input } from 'client/widget-components/basicComponents/Input/Input';
import React, { useEffect, useRef } from 'react';

interface FileInputWithEventProps
    extends React.ComponentPropsWithoutRef<typeof Input> {}

// Inputs which trigger 'input' events when rendered - the form catch them and removes validation errors
export const InvisibleInputWithEvent: React.FC<FileInputWithEventProps> = (
    props
) => {
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (inputRef.current) {
            const inputEvent = new Event('input', {
                bubbles: true,
                cancelable: true,
            });
            inputRef.current.dispatchEvent(inputEvent);
        }
    }, []);

    return <Input ref={inputRef} styles={invisibleInputStyles} {...props} />;
};

export const invisibleInputStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        display: 'none',
    },
};
